<template>
  <v-menu
    v-if="isVisible"
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    left
    nudge-bottom="8"
    min-width="380"
    max-width="440"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-badge
          :value="count > 0"
          :content="count"
          color="red darken-2"
          overlap
        >
          <v-icon :class="{ 'cob-pulse': count > 0 }" :color="count > 0 ? 'red darken-2' : ''">
            local_shipping
          </v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense flat color="red darken-2" dark>
        <v-icon left>schedule</v-icon>
        <v-toolbar-title class="subheading">Tarihi Geçen Kargolar</v-toolbar-title>
        <v-spacer />
        <v-chip v-if="count > 0" small color="white" text-color="red darken-2">
          {{ count }}
        </v-chip>
      </v-toolbar>

      <div v-if="unmatchedCityCount > 0" class="cob-warn">
        <v-icon small color="orange darken-2">warning</v-icon>
        <span>{{ unmatchedCityCount }} sipariş "DeliveryCities"de eşleşmedi (gecikme hesaplanamadı)</span>
      </div>

      <v-list v-if="items.length > 0" two-line dense class="py-0" style="max-height: 380px; overflow-y: auto;">
        <template v-for="(n, i) in items">
          <v-list-tile :key="n.orderId" @click="goToOverdue(n)">
            <v-list-tile-avatar>
              <v-icon color="red darken-2">error</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">
                #{{ n.orderId }} · {{ n.recipientName || '—' }}
                <span class="caption grey--text">· {{ n.city || '—' }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span class="red--text text--darken-2 font-weight-bold">{{ n.daysOverdue }} gün gecikti</span>
                · Beklenen: {{ formatDate(n.expectedDeliveryDate) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="i < items.length - 1" :key="'d-' + n.orderId" />
        </template>
      </v-list>

      <v-card-text v-else class="text-xs-center grey--text py-4">
        <v-icon large color="grey lighten-1">check_circle_outline</v-icon>
        <div class="mt-2">Tarihi geçmiş kargo yok</div>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn flat small color="red darken-2" @click="goToOverdue()">
          Tümünü Gör
          <v-icon right small>arrow_forward</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import yurticiKargoApi from "@/api/yurticiKargo";

export default {
  name: 'CargoOverdueBell',
  data() {
    return {
      menu: false,
      pollHandle: null,
      count: 0,
      unmatchedCityCount: 0,
      items: [],
    };
  },
  computed: {
    isVisible() {
      const t = parseInt(localStorage.getItem('selectedTenantId') || '0', 10);
      const m = parseInt(localStorage.getItem('selectedMpId') || '0', 10);
      return t === 1 && m === 5;
    },
  },
  mounted() {
    if (this.isVisible) {
      this.refresh();
      this.pollHandle = setInterval(this.refresh, 5 * 60 * 1000);
    }
  },
  beforeDestroy() {
    if (this.pollHandle) clearInterval(this.pollHandle);
  },
  methods: {
    async refresh() {
      if (!this.isVisible) return;
      try {
        const res = await yurticiKargoApi.overdueNotifications(20);
        const data = (res && res.data) || {};
        this.count = data.count || 0;
        this.unmatchedCityCount = data.unmatchedCityCount || 0;
        this.items = data.items || [];
      } catch (e) {
        this.count = 0;
        this.unmatchedCityCount = 0;
        this.items = [];
      }
    },
    goToOverdue(notification) {
      this.menu = false;
      const query = { tab: 'overdue' };
      if (notification && notification.orderId) query.orderId = String(notification.orderId);
      if (this.$route.path !== '/kargo-bilgileri' || JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.push({ path: '/kargo-bilgileri', query }).catch(() => {});
      }
    },
    formatDate(v) {
      if (!v) return '—';
      const d = new Date(v);
      return d.toLocaleDateString('tr-TR');
    },
  },
};
</script>

<style scoped>
@keyframes cob-shake {
  0%, 70%, 100% { transform: rotate(0deg); }
  76% { transform: rotate(-10deg); }
  82% { transform: rotate(10deg); }
  88% { transform: rotate(-6deg); }
  94% { transform: rotate(6deg); }
}
.cob-pulse {
  animation: cob-shake 3.5s ease-in-out infinite;
  transform-origin: 50% 50%;
}
.cob-warn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #b45309;
  background: #fff7ed;
  border-bottom: 1px solid #fed7aa;
  padding: 6px 12px;
}
</style>
